import React, { Component } from 'react'

export class DragDropIcon extends Component {
	render() {
		return (
			<svg width="64" height="44" viewBox="0 0 64 44" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M51.6 16.7734C50.7043 12.234 48.2603 8.14637 44.6855
				5.20874C41.1107 2.2711 36.627 0.665702 32 0.666749C24.2933
				0.666749 17.6 5.04008 14.2667 11.4401C10.3473 11.8636 6.72268
				13.7206 4.0893 16.6543C1.45592 19.5879 -0.000457871 23.3912
				1.07981e-07 27.3334C1.07981e-07 36.1601 7.17333 43.3334 16
				43.3334H50.6667C58.0267 43.3334 64 37.3601 64 30.0001C64 22.9601
				58.5333 17.2534 51.6 16.7734ZM50.6667 38.0001H16C10.1067 38.0001
				5.33333 33.2267 5.33333 27.3334C5.33333 21.8667 9.41333 17.3067
				14.8267 16.7467L17.68 16.4534L19.0133 13.9201C20.2397 11.5328 22.101
				9.53026 24.3923 8.13287C26.6837 6.73548 29.3162 5.99746 32
				6.00008C38.9867 6.00008 45.0133 10.9601 46.3733 17.8134L47.1733
				21.8134L51.2533 22.1067C53.258 22.2416 55.1371 23.1307 56.5126
				24.5952C57.8881 26.0598 58.6577 27.9909 58.6667 30.0001C58.6667
				34.4001 55.0667 38.0001 50.6667 38.0001ZM21.3333
				24.6667H28.1333V32.6667H35.8667V24.6667H42.6667L32 14.0001L21.3333 24.6667Z" fill="#00538A" />
			</svg>
		)
	}
}

export default DragDropIcon
